import {
	Header as SymbiosisHeader,
	HeaderHandler as SymbiosisHeaderHandler,
} from 'symbiosis-uikit'
import { ConnectWalletBtn } from '~/components/ConnectWalletBtn'

import styles from './Header.pcss'
import { useEffect, useRef } from 'react'
import { Link, useLocation } from 'react-router-dom'

function Header(): JSX.Element {
	const header = useRef<SymbiosisHeaderHandler>(null)
	const { pathname } = useLocation()

	// Close header on route change
	useEffect(() => {
		header.current?.close()
	}, [pathname])

	return (
		<SymbiosisHeader
			className={styles.header}
			ref={header}
			activeItem="earn"
			rightContent={<ConnectWalletBtn />}
			onPromoAction={() => {
				window.open('https://symbiosis.finance/metamask/tron', '_blank')
			}}
			 renderLink={({ href, className, children }) => {
                const origin = 'https://rewards.symbiosis.finance'
                if (href.startsWith(origin)) {
                    return (
                        <Link
                            to={href.slice(origin.length)}
                            className={className}
                        >
                            {children}
                        </Link>
                    )
                }
                return (
                    <a
                        href={href}
                        className={className}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {children}
                    </a>
                )
            }}
		/>
	)
}

export default Header
